// extracted by mini-css-extract-plugin
export default {"marqueeRect":"SvrNyQCJ793jlejvJWPO"};